import { render, staticRenderFns } from "./SettingTemplate.vue?vue&type=template&id=7288b173&scoped=true"
import script from "./SettingTemplate.vue?vue&type=script&lang=js"
export * from "./SettingTemplate.vue?vue&type=script&lang=js"
import style0 from "./SettingTemplate.vue?vue&type=style&index=0&id=7288b173&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7288b173",
  null
  
)

export default component.exports